import React from "react";
import "./Dashboard.css";

const Dashboard = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="dashboard">
      <div className="dashboard-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.id === "business-post" && (
              <img src="/logo.png" alt="B2World Logo" className="tab-logo" />
            )}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
